import * as React from "react";
import { TableRow } from "./TableRow";
import * as I18n from "../../../utils/translations/I18n";
export var TableBody = function (props) { return (React.createElement("tbody", { className: "scl-m-table__body" }, props.rows && props.rows.length > 0 ?
    (props.rows.map(function (row, index) { return (React.createElement(TableRow, { rowData: row, key: "tr-".concat(index), even: index % 2 === 0 ? true : false, hasActions: !!props.hasActions, dataColumns: props.columns, themePalleteState: row.themePalleteState })); })) : (React.createElement("tr", { className: "scl-m-table__tr" },
    React.createElement("td", { className: "scl-m-table__td scl-h-text-align--center", colSpan: props.columns.length },
        React.createElement("br", null),
        I18n.getText("mary.06-molecules.tablebody.no-results", "No results to display."),
        React.createElement("br", null),
        React.createElement("br", null)))))); };
